import React, { useEffect } from 'react'
import { useParams } from "react-router-dom"
import Navbar from '../Navbar/Navbar'
import BreadCrumbNav from '../Navbar/BreadCrumbNav'
import ImagesGallery from './ImagesGallery'
import CallToActionButtons from './CallToActionButtons'
import ProductOverview from './ProductOverview'
import ProductVideo from './ProductVideo'
import ProductDescription from './ProductDescription'
import RatingsAndReviews from './RatingsAndReviews'
import TractorSlider from '../Tractor/TractorSlider'
import Faq from './Faq'
import ShareProduct from './ShareProduct'
import TractorSpecifications from './TractorSpecifications';
import Footer from '../Footer'
import QuickLinks from '../Navbar/QuickLinks'


export default function TractorDetailed() {

    const { type, productId } = useParams();
    useEffect(() => window.scrollTo(0, 0), [])

    return (
        <div>
            <Navbar />
            <div>
                <div className="md:grid md:grid-cols-5">
                    <div className="md:col-span-2">
                        <ImagesGallery type={type} productId={productId} />
                        <CallToActionButtons type={type} productId={productId} />
                    </div>
                    <div className="md:col-span-3">
                        <div className="md:overflow-auto scroll-height">
                            <BreadCrumbNav items={["Mahindra", "New Tractors"]} />
                            <ProductOverview type={type} productId={productId} />
                            <ProductVideo type={type} productId={productId} />
                            <ProductDescription type={type} productId={productId} />
                            <TractorSpecifications type={type} productId={productId} />
                            <RatingsAndReviews type={type} productId={productId} />
                            <Faq type={type} productId={productId} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-3 m-4 bg-white rounded shadow">
                <div className="mx-3">
                    <h1 className="text-2xl font-semibold text-gray-700 border-b border-gray-200">Similar to Massey Ferguson 1035 DI</h1>
                </div>
                <TractorSlider category="POPULAR" />
            </div>

            <div className="fixed hidden md:block" style={{top: "30%", right: 0}}>
                <ShareProduct type={type} productId={productId} />
            </div>

            <div>
                <QuickLinks />
            </div>

            <Footer />
                
        </div>
    )
}
